module.exports = __webpack_public_path__ + "img/title6.9bb64bfd.png";